import { App } from 'vue'

const requireComponent = require.context('../components/icons', false, /[\w]+\.vue$/)

export const registerIcons = (app: App<Element>) => {
    // register each component
    requireComponent.keys().forEach(fileName => {
        const componentConfig = requireComponent(fileName)
        // remove from filename './' from beginning, '.vue' at the end
        const componentName = `Icon${fileName.substr(0, fileName.length - 4).substr(2)}`
        // register component
        app.component(componentName, componentConfig.default || componentConfig)
    })
}
